// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.picklist {
  display: flex;
  height: 100%;
  position: relative;
}

:not(.is-expanded) .picklist-section::before {
  background-color: var(--ids-color-transparent);
}

.picklist-section {
  height: 100%;
  width: 50%;
  flex: 0 0 50%;
}
.picklist-section:only-child {
  width: 100%;
  flex: 0 0 100%;
}
.picklist-section + .picklist-section::before {
  background-color: var(--ids-color-neutral-30);
  position: absolute;
  content: " ";
  width: 1px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: calc(75% + 14px);
  top: calc(12.5% - 4px);
}

.picklist-list {
  display: flex;
  list-style: none;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
  height: 100%;
}

.picklist-item {
  display: flex;
  cursor: pointer;
  border: 1px solid transparent;
  color: var(--ids-date-picker-picklist-item-color-text-default);
  padding-block: 1px;
  box-sizing: border-box;
  user-select: none;
  height: 12.5%;
  align-items: center;
  justify-content: center;
  contain: content;
  width: 100%;
}
.picklist-item ids-text {
  line-height: 0;
}
.picklist-item.is-selected {
  color: var(--ids-date-picker-picklist-item-color-text-selected);
  background-color: var(--ids-date-picker-picklist-item-color-background-selected);
}
.picklist-item.is-selected ids-text::part(text) {
  font-weight: 600;
}
.picklist-item:not(.is-year-nav):not(.is-month-nav):focus {
  border-color: var(--ids-date-picker-item-color-border-focus);
  box-shadow: var(--ids-date-picker-item-shadow-focus);
  outline: none;
}
.picklist-item.is-year-nav, .picklist-item.is-month-nav {
  z-index: 1;
}
.picklist-item.is-month-nav {
  width: calc(100% + 1px);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-date-picker/ids-month-year-picklist.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,8CAAA;AAAF;;AAGA;EACE,YAAA;EACA,UAAA;EACA,aAAA;AAAF;AAEE;EACE,WAAA;EACA,cAAA;AAAJ;AAKI;EACE,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,sBAAA;AAHN;;AAQA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AALF;;AAQA;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,8DAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AALF;AAOE;EACE,cAAA;AALJ;AAQE;EACE,+DAAA;EACA,gFAAA;AANJ;AAQI;EACE,gBAAA;AANN;AAWI;EACE,4DAAA;EACA,oDAAA;EACA,aAAA;AATN;AAaE;EAEE,UAAA;AAZJ;AAeE;EACE,uBAAA;AAbJ","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n// Picklist\n.picklist {\n  display: flex;\n  height: 100%;\n  position: relative;\n}\n\n:not(.is-expanded) .picklist-section::before {\n  background-color: var(--ids-color-transparent);\n}\n\n.picklist-section {\n  height: 100%;\n  width: 50%;\n  flex: 0 0 50%;\n\n  &:only-child {\n    width: 100%;\n    flex: 0 0 100%;\n  }\n\n  + .picklist-section {\n    // section separator\n    &::before {\n      background-color: var(--ids-color-neutral-30);\n      position: absolute;\n      content: ' ';\n      width: 1px;\n      left: 0;\n      right: 0;\n      margin-left: auto;\n      margin-right: auto;\n      height: calc(75% + 14px);\n      top: calc(12.5% - 4px);\n    }\n  }\n}\n\n.picklist-list {\n  display: flex;\n  list-style: none;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  height: 100%;\n}\n\n.picklist-item {\n  display: flex;\n  cursor: pointer;\n  border: 1px solid transparent;\n  color: var(--ids-date-picker-picklist-item-color-text-default);\n  padding-block: 1px;\n  box-sizing: border-box;\n  user-select: none;\n  height: 12.5%;\n  align-items: center;\n  justify-content: center;\n  contain: content;\n  width: 100%;\n\n  ids-text {\n    line-height: 0;\n  }\n\n  &.is-selected {\n    color: var(--ids-date-picker-picklist-item-color-text-selected);\n    background-color: var(--ids-date-picker-picklist-item-color-background-selected);\n\n    ids-text::part(text) {\n      font-weight: 600;\n    }\n  }\n\n  &:not(.is-year-nav):not(.is-month-nav) {\n    &:focus {\n      border-color: var(--ids-date-picker-item-color-border-focus);\n      box-shadow: var(--ids-date-picker-item-shadow-focus);\n      outline: none;\n    }\n  }\n\n  &.is-year-nav,\n  &.is-month-nav {\n    z-index: 1;\n  }\n\n  &.is-month-nav {\n    width: calc(100% + 1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
